import { request } from './request'
// 获取计划任务列表  旧
export interface GetJobListy {
  limit: number
  page: number
  name?: string
}
export const getJobListy = (data: GetJobListy) =>
  request('/portal/verify/webGateway/jobList', {
    params: {
      ...data,
    },
  })
// // 删除计划任务列表
// export interface DeleteTask {
//   id: number
// }
// export const deleteTask = (data: DeleteTask) =>
//   request('/portal/verify/webGateway/deleteTask', {
//     method: 'delete',
//     data,
//   })

// //  获取计划详情
// export interface GetJobDetail {
//   id: number
// }
// export const getJobDetail = (data: GetJobDetail) =>
//   request('/portal/verify/webGateway/jobDetail', {
//     params: {
//       ...data,
//     },
//   })

// // // 获取列表数量详情
// // export interface GetWebDetail {
// //   task_id: number
// //   portal_id: number
// //   status: '1' | '2'
// // }
// // export const getWebDetail = (data: GetWebDetail) =>
// //   request('/portal/verify/webGateway/jobResultScore', {
// //     params: {
// //       ...data,
// //     },
// //   })
// // // 获取模板列表
// // export interface GetJobResultTemplateList {
// //   portal_id: number | string
// //   task_id: number | string

// //   limit: number
// //   page: number
// //   status: number
// // }
// // export const getJobResultTemplateList = (data: GetJobResultTemplateList) =>
// //   request('/portal/verify/webGateway/jobResultTemplateList', {
// //     params: {
// //       ...data,
// //     },
// //   })
// // // 获取子模板列表详情
// // export interface GetJobResultTemplateResourceList {
// //   limit: number
// //   page: number
// //   portal_id: string
// //   template_id: string
// //   risk_level?: number
// //   name?: string
// //   flag?: number
// // }
// // export const getJobResultTemplateResourceList = (data: GetJobResultTemplateResourceList) =>
// //   request('/portal/verify/webGateway/jobResultTemplateResourceList', {
// //     params: {
// //       ...data,
// //     },
// //   })

// // // 获取refs

// // export const getRefs = () => request('/portal/verify/webGateway/refs')

// 获取计划任务列表
export interface GetJobList {
  limit: number
  page: number
  keyword?: string
  start_time?: string
  end_time?: string
  scheduler_type?: string | number
  biz_area?: string
}
export const getJobList = (data: GetJobList) =>
  request('/portal/verify/webGateway/jobList', {
    params: {
      ...data,
    },
  })

// 获取安全域列表
export const getBizAreaList = () => request('/portal/verify/webGateway/jobBizAreaList')

// 获取计划详情
export interface GetJobDetail {
  id: string
}
export const getJobDetail = (data: GetJobDetail) =>
  request('/portal/verify/webGateway/jobDetail', {
    params: {
      ...data,
    },
  })

// 暂停/重启 计划任务
export interface ChangeJobStatus {
  id: string
  task_status: number
}
export const changeJobStatus = (data: ChangeJobStatus) =>
  request('/portal/verify/webGateway/changeJobStatus', {
    method: 'PUT',
    data,
  })

// 删除计划任务列表
export interface DeleteTask {
  id: string
}
export const deleteTask = (data: DeleteTask) =>
  request('/portal/verify/webGateway/deleteJob', {
    method: 'delete',
    data,
  })

// 批量删除计划任务列表
export interface BatchDeleteJob {
  id_list: string[]
}
export const batchDeleteJob = (data: BatchDeleteJob) =>
  request('/portal/verify/webGateway/batchDeleteJob', {
    method: 'delete',
    data,
  })
